import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DesktopDateTimePicker } from "@mui/x-date-pickers/DesktopDateTimePicker";
import { TextField, IconButton, InputAdornment } from "@mui/material";
import { it, enUS, fr, de } from "date-fns/locale"; // Importa le lingue necessarie
import ClearIcon from "@mui/icons-material/Clear";

interface Props {
  date: string | null;
  onChange: (date: string | null) => void;
  error?: boolean;
  minDate?: Date | null;
  maxDate?: Date | null;
}

// Mappa delle lingue supportate
const localeMap: { [key: string]: Locale } = {
  "it-IT": it,
  "en-US": enUS,
  "fr-FR": fr,
  "de-DE": de,
};

// Funzione per ottenere la lingua dell'utente o default a inglese
const getUserLocale = () => {
  const userLang =  "en-US";
  return localeMap[userLang] || enUS;
};

const CustomDatePicker: React.FC<Props> = ({ date, onChange, error, minDate, maxDate }) => {
  const userLocale = getUserLocale();
  const parsedDate = date ? (typeof date === 'string' ? new Date(date.replace("T", " ")) : new Date(date)) : null;
  
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={userLocale}>
      <DesktopDateTimePicker
        inputFormat="dd/MM/yyyy HH:mm"
        value={parsedDate}
        onChange={(newDate) =>
          onChange(newDate ? newDate.toISOString() : null)
        }
        views={["year", "month", "day", "hours", "minutes"]}
        ampm={false}
        minutesStep={5}
        disableOpenPicker={false}
        minDateTime={minDate}
        maxDateTime={maxDate}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            error={error}
            helperText={error ? "Data non valida" : ""}
            onKeyDown={(e) => e.preventDefault()} // Blocca input manuale
            onMouseDown={(e) => e.preventDefault()} // Impedisce il click sul campo
            sx={{
              "& .MuiInputBase-root": { height: 41 },
              "& .MuiTypography-root": { fontSize: "0.85rem" },
            }}
            InputProps={{
              ...params.InputProps,
              readOnly: true,
              endAdornment: (
                <>
                  {date && (
                    <InputAdornment position="end">
                      <IconButton onClick={() => onChange(null)} size="small">
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  )}
                  {params.InputProps?.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default CustomDatePicker;
